import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = ["icon", "feedback"]

  copy() {
    const text = this.hasTextValue
      ? this.textValue
      : this.element.closest(".relative")?.querySelector("code")?.textContent

    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      if (text.includes("bundle add") || text.includes("gem install")) {
        const gem = text.match(/(?:bundle add|gem install)\s+(\S+)/)?.[1] || "unknown"
        window.ahoy?.track("gem_install_copied", { gem })
      }

      if (this.hasFeedbackTarget) {
        this.feedbackTarget.classList.remove("hidden")
        setTimeout(() => this.feedbackTarget.classList.add("hidden"), 2000)
      } else {
        const btn = this.element
        const original = btn.textContent
        btn.textContent = "Copied!"
        setTimeout(() => { btn.textContent = original }, 2000)
      }
    })
  }
}
